import React from 'react';
import { footerData } from './api/footerData';
import Layout from "@/lib/Layout/Layout";

const ReturnsAndRefundPolicy: React.FC = () => {
    return (
        <Layout footerData={footerData}>
            <div className='mx-8 md:mx-auto mt-5 md:mt-10 md:w-1/2 mb-16'>
                <h1 className="text-2xl md:text-6xl font-bold mb-4 md:mb-8">Returns and Refund Policy for Bonatra</h1>
                <p className="text-sm md:text-xl">
                    We{"’"}re genuinely grateful that you chose us. Our primary aim is to ensure that you{"'"}re delighted with our offerings. Here{"'"}s a comprehensive guideline on our Returns and Refund policies, crafted with your well-being and satisfaction in mind.
                </p>

                <div className='border border-solid border-[#22C55E] my-4 md:my-8'></div>

                <div className="mb-8">
                    <h2 className="text-lg md:text-3xl font-bold mb-2 md:mb-8">CGM (Continuous Glucose Monitoring) Device by Abbott Diabetes Control:</h2>
                    <p className="text-sm md:text-2xl mb-2 font-semibold">No Return Policy:</p>
                    <ul className="list-disc list-inside text-xs md:text-lg mb-4">
                        <li style={{ display: "flex", alignItems: "flex-start", marginBottom: "4px" }}>
                            <span style={{ minWidth: "0.75em", display: "inline-block", fontSize: "1.25rem" }}>•</span>
                            Once the CGM box seal is opened, we cannot accept a return.
                        </li>
                        <li style={{ display: "flex", alignItems: "flex-start" }}>
                            <span style={{ minWidth: "0.75em", display: "inline-block", fontSize: "1.25rem" }}>•</span>
                            Installation errors on the part of the user despite the numerous avenues of support we provide.
                        </li>
                        <li style={{ display: "flex", alignItems: "flex-start" }}>
                            <span style={{ minWidth: "0.75em", display: "inline-block", fontSize: "1.25rem" }}>•</span>
                            CGM once shipped to the users cannot be returned back.
                        </li>
                    </ul>
                    <p className="text-sm md:text-2xl mb-2 font-semibold">Why We Don{"'"}t Accept Returns:</p>
                    <ul className="list-disc list-inside text-xs md:text-lg mb-4">
                        <li style={{ display: "flex", alignItems: "flex-start", marginBottom: "4px" }}>
                            <span style={{ minWidth: "0.75em", display: "inline-block", fontSize: "1.25rem" }}>•</span>
                            Our CGM is an IVD (In-Vitro Diagnostic) medical device, equivalent in hygiene and safety importance to items like syringes. For the safety of our users and to maintain the highest standards of hygiene, an opened CGM cannot be reused or resealed.
                        </li>
                        <li style={{ display: "flex", alignItems: "flex-start", marginBottom: "4px" }}>
                            <span style={{ minWidth: "0.75em", display: "inline-block", fontSize: "1.25rem" }}>•</span>
                            We extend a comprehensive support system to our users to assist with the installation:
                        </li>   
                        <ul className="list-disc list-inside text-xs md:text-lg mb-2 ml-4 md:ml-6">
                            <li>Step-by-step installation guides shared via WhatsApp.</li>
                            <li>Detailed instructions available on the Bonatra app.</li>
                            <li>Our dedicated customer support is always ready to assist.</li>
                        </ul>
                        <li style={{ display: "flex", alignItems: "flex-start" }}>
                            <span style={{ minWidth: "0.75em", display: "inline-block", fontSize: "1.25rem" }}>•</span>
                            The CGM{"'"}s reputation for reliability and effectiveness is further solidified with its US FDA approval.
                        </li>
                    </ul>
                    <p className="text-sm md:text-2xl mb-2 font-semibold">Conditions for Return Acceptance:</p>
                    <h2 className='text-xs md:text-lg font-bold'>Libre PRO</h2>
                    <p className="text-xs md:text-lg mb-4">
                        We understand that no technology is perfect, In the event that a LIBRE PRO CGM sensor malfunctions/or shows inconsistencies or experiences a failure within the first 3 days (72 hours) of use, we will facilitate a return provide a replacement sensor. Please note that replacements will not be offered if the malfunction is due to incorrect installation by the user.
                    </p>
                    <h2 className='text-xs md:text-lg font-bold'>LIBRE 1</h2>
                    <p className="text-xs md:text-lg mb-2">
                        For any malfunctions or issues with the LIBRE 1 sensor, we kindly request you to directly contact Abbott Support for assistance and resolution. Please be aware that we cannot offer support or replacements for LIBRE 1 sensors.
                    </p>
                </div>

                <div className='border border-solid border-[#22C55E] my-4 md:my-8'></div>

                <div className="mb-8">
                    <h2 className="text-lg md:text-3xl font-bold mb-2 md:mb-8">Programs:</h2>
                    <p className="text-sm md:text-2xl mb-2 font-semibold">No Return Policy:</p>
                    <ul className="list-disc list-inside text-xs md:text-lg mb-4">
                        <li style={{ display: "flex", alignItems: "flex-start" }}>
                            <span style={{ minWidth: "0.75em", display: "inline-block", fontSize: "1.25rem" }}>•</span>
                            Due to the personalized nature of our programs, we generally do not accept returns or offer refunds once a program is initiated.
                        </li>

                    </ul>
                    <p className="text-sm md:text-2xl mb-2 font-semibold">Why We Don{"'"}t Take Returns:</p>
                    <ul className="list-disc list-inside text-xs md:text-lg mb-4">
                        <li style={{ display: "flex", alignItems: "flex-start", marginBottom: "4px" }}>
                            <span style={{ minWidth: "0.75em", display: "inline-block", fontSize: "1.25rem" }}>•</span>
                            The resources allocated, like consultations with health coaches and doctors, and the consumables like CGMs and supplements, once used, are non-refundable.
                        </li>
                        <li style={{ display: "flex", alignItems: "flex-start" }}>
                            <span style={{ minWidth: "0.75em", display: "inline-block", fontSize: "1.25rem" }}>•</span>
                            Our programs are tailored specifically to individual health needs and progress, and as such, the time and effort spent by our professionals are dedicated and cannot be refunded.
                        </li>
                    </ul>
                    <p className="text-sm md:text-2xl mb-2 font-semibold">Conditions for Return Acceptance:</p>
                    <p className="text-xs md:text-lg">If a program has been purchased but not yet initiated, and no consumables have been dispatched or used, a refund may be considered on a case-by-case basis.</p>
                </div>

                <div className='border border-solid border-[#22C55E] my-4 md:my-8'></div>

                <div className="mb-8">
                    <h2 className="text-lg md:text-3xl font-bold mb-2 md:mb-8">Smart Ring:</h2>
                    <p className="text-sm md:text-2xl mb-2 font-semibold">Warranty:</p>
                    <p className="text-xs md:text-lg mb-2">We{"'"}re proud of our Smart Ring{"'"}s build quality, but should you face manufacturing defects, we offer a 6-month warranty.</p>
                    <p className="text-sm md:text-2xl mb-2 font-semibold">Return Window:</p>
                    <p className="text-xs md:text-lg mb-2">Being a novel concept, we provide a 7-day window from the delivery date for you to get acquainted and comfortable. If you{"'"}re unsatisfied, you can return it within this period.</p>
                    <p className="text-sm md:text-2xl mb-2 font-semibold">Conditions for Non-returnability:</p>
                    <ul className="list-disc list-inside text-xs md:text-lg mb-2">
                        <li>Damages or scratches, as these could affect functionality</li>
                        <li>Missing parts, ensuring you get a complete experience.</li>
                    </ul>
                </div>

                <div className='border border-solid border-[#22C55E] my-4 md:my-8'></div>

                <div className="mb-8">
                    <h2 className="text-lg md:text-3xl font-bold mb-2 md:mb-8">Supplements:</h2>
                    <p className="text-sm md:text-2xl mb-2 font-semibold">Conditions for Refund:</p>
                    <ul className="list-disc list-inside text-xs md:text-lg mb-4">
                        <li style={{ display: "flex", alignItems: "flex-start" }}>
                            <span style={{ minWidth: "0.75em", display: "inline-block", fontSize: "1.25rem" }}>•</span>
                            We prioritize your health, hence only unopened bottles are eligible for refunds to maintain integrity and hygiene.
                        </li>
                        <li style={{ display: "flex", alignItems: "flex-start" }}>
                            <span style={{ minWidth: "0.75em", display: "inline-block", fontSize: "1.25rem" }}>•</span>
                            Please initiate refunds before dispatch for timely processing.
                        </li>
                    </ul>
                </div>

                <div className='border border-solid border-[#22C55E] my-4 md:my-8'></div>

                <div className="mb-8">
                    <h2 className="text-lg md:text-3xl font-bold mb-2 md:mb-8">Supplements & Consumables (e.g., Keto Flour, Cookies):</h2>
                    <p className="text-sm md:text-2xl mb-2 font-semibold">No Return Policy</p>
                    <ul className="list-disc list-inside text-xs md:text-lg mb-4">
                        <li style={{ display: "flex", alignItems: "flex-start" }}>
                            <span style={{ minWidth: "0.75em", display: "inline-block", fontSize: "1.25rem" }}>•</span>
                            Due to hygiene and quality assurance reasons, consumables, once purchased, are generally non-returnable.
                        </li>
                    </ul>
                    <p className="text-sm md:text-2xl mb-2 font-semibold">Why We Don{"'"}t Take Returns</p>
                    <ul className="list-disc list-inside text-xs md:text-lg mb-4">
                        <li style={{ display: "flex", alignItems: "flex-start", marginBottom: "4px" }}>
                            <span style={{ minWidth: "0.75em", display: "inline-block", fontSize: "1.25rem" }}>•</span>
                            Consumables have a limited shelf life, and once dispatched, we cannot ensure their quality if returned.
                        </li>
                        <li style={{ display: "flex", alignItems: "flex-start" }}>
                            <span style={{ minWidth: "0.75em", display: "inline-block", fontSize: "1.25rem" }}>•</span>
                            This is a standard industry practice to ensure that every customer receives the freshest and safest products.
                        </li>
                    </ul>
                    <p className="text-sm md:text-2xl mb-2 font-semibold mb-2">Exceptions:</p>
                    <p className="text-xs md:text-lg">If you receive the wrong product or if the product arrives damaged, please get in touch with our customer service immediately for resolution.</p>
                </div>

                <div className='border border-solid border-[#22C55E] my-4 md:my-8'></div>

                <div>
                    <h2 className="text-lg md:text-3xl font-bold mb-2 font-semibold">General Conditions:</h2>
                    <p className="text-xs md:text-lg mb-2">Rest assured, we do not charge any restocking fee.</p>
                    <p className="text-xs md:text-lg mb-2">For our local Bonatra family, return shipping is on us within India! For our international family, we have nominal charges.</p>
                    <p className="text-xs md:text-lg mb-2">Please keep your purchase proof handy for any returns or refunds to facilitate a smoother process.</p>
                </div>

                <div className='border border-solid border-[#22C55E] my-8 md:my-8'></div>

                <p className="text-sm md:text-lg mb-4">
                    Your trust means the world to us. For any clarifications, concerns, or feedback, please don{"’"}t hesitate to reach out. Together, let{"'"}s journey towards better health and happiness.
                </p>

                <p className="text-sm md:text-lg">Warmly,</p>
                <p className="text-sm md:text-lg">The Bonatra Team</p>
            </div>
        </Layout>
    );
};

export default ReturnsAndRefundPolicy;

// const ReturnsAndRefundPolicy: React.FC = () => {
//     return (
//         <Layout footerData={footerData}>
//             <div className="font-sans bg-gray-100 text-gray-800 md:w-1/2 md:m-auto p-6 md:p-8">
//                 <h1 className="text-3xl md:text-4xl font-bold mb-4">
//                     Returns and Refund Policy for Bonatra
//                 </h1>
//                 <p className="mb-4">
//                     Dear Bonatra Family,
//                 </p>
//                 <p className="mb-4">
//                     We{"’"}re genuinely grateful that you chose us. Our primary aim is to ensure that you{"'"}re delighted with our offerings. Here{"'"}s a comprehensive guideline on our Returns and Refund policies, crafted with your well-being and satisfaction in mind.
//                 </p>

//                 <h2 className="text-xl md:text-2xl font-semibold mt-8 mb-4">
//                     CGM (Continuous Glucose Monitoring) Device by Abbott Diabetes Control
//                 </h2>
//                 <p className="mb-4">
//                     <span className="font-semibold">No Trial Period:</span> Our trust in the CGM{"'"}s accuracy and efficacy is rooted in its strong reputation and the value it brings to our users.
//                 </p>
//                 <p className="mb-4">
//                     <span className="font-semibold">Quality Assurance:</span> Proudly, our CGM is endorsed with a US FDA approval, ensuring international standards of reliability and effectiveness for you.
//                 </p>
//                 <p className="mb-4">
//                     <span className="font-semibold">Conditions for Non-returnability:</span> If the CGM box seal is opened. It{"'"}s important to note that the CGM functions as an IVD (In-Vitro Diagnostic) medical device, akin to a syringe. This means once it{"'"}s opened, for reasons of safety and hygiene, it cannot be reused or re-sealed.
//                 </p>
//                 <p className="mb-6">
//                     <span className="font-semibold">Installation errors despite our support avenues:</span>
//                 </p>
//                 <ul className="list-disc ml-8 mb-4">
//                     <li>Clear installation guides via WhatsApp.</li>
//                     <li>Detailed in-app instructions on the Bonatra platform.</li>
//                     <li>Our committed customer support to guide you.</li>
//                 </ul>
//                 <p className="mb-4">
//                     <span className="font-semibold">Acceptable Returns:</span> Technology, although sophisticated, might occasionally have hitches. Should your CGM device get Crashed within 72 hours of activation, we{"'"}re here to support and facilitate returns.
//                 </p>

//                 <h2 className="text-xl md:text-2xl font-semibold mt-8 mb-4">
//                     Programs
//                 </h2>
//                 <p className="mb-4">
//                     <span className="font-semibold">Non-refundable Components:</span>
//                 </p>
//                 <ul className="list-disc ml-8 mb-4">
//                     <li>Consumables like CGM and supplements, due to hygiene and safety considerations.</li>
//                     <li>Consultation time with our dedicated doctors and coaches, as their time and expertise are valuable.</li>
//                 </ul>
//                 <p className="mb-4">
//                     <span className="font-semibold">No Grace Period:</span> Our programs are tailored for dedicated health outcomes over specific durations.
//                 </p>

//                 <h2 className="text-xl md:text-2xl font-semibold mt-8 mb-4">
//                     Smart Ring
//                 </h2>
//                 <p className="mb-4">
//                     <span className="font-semibold">Warranty:</span> We{"'"}re proud of our Smart Ring{"'"}s build quality, but should you face manufacturing defects, we offer a 6-month warranty.
//                 </p>
//                 <p className="mb-4">
//                     <span className="font-semibold">Return Window:</span> Being a novel concept, we provide a 7-day window from the delivery date for you to get acquainted and comfortable.
//                 </p>
//                 <p className="mb-4">
//                     <span className="font-semibold">Conditions for Non-returnability:</span> Damages or scratches, as these could affect functionality.
//                 </p>
//                 <p className="mb-6">
//                     <span className="font-semibold">Missing parts:</span> Ensuring you get a complete experience.
//                 </p>

//                 <h2 className="text-xl md:text-2xl font-semibold mt-8 mb-4">
//                     Supplements
//                 </h2>
//                 <p className="mb-4">
//                     <span className="font-semibold">Conditions for Refund:</span> We prioritize your health, hence only unopened bottles are eligible for refunds to maintain integrity and hygiene.
//                 </p>
//                 <p className="mb-6">
//                     <span className="font-semibold">Consumables (e.g., Keto Flour, Cookies):</span>
//                 </p>
//                 <p className="mb-4">
//                     <span className="font-semibold">Refund Policy:</span> Due to the perishable nature and our commitment to freshness, we maintain a no-refund policy for consumables.
//                 </p>

//                 <h2 className="text-xl md:text-2xl font-semibold mt-8 mb-4">
//                     General Conditions
//                 </h2>
//                 <p className="mb-4">
//                     Rest assured, we do not charge any restocking fee.
//                 </p>
//                 <p className="mb-4">
//                     For our local Bonatra family, shipping is on us within India! For our international family, we have nominal charges.
//                 </p>
//                 <p className="mb-6">
//                     Please keep your purchase proof handy for any returns or refunds to facilitate a smoother process.
//                 </p>

//                 <p className="mb-4">
//                     Your trust means the world to us. For any clarifications, concerns, or feedback, please don{"’"}t hesitate to reach out. Together, let{"'"}s journey towards better health and happiness.
//                 </p>
//                 <p className="mb-4">
//                     Warmly, The Bonatra Team
//                 </p>
//             </div>
//         </Layout>
//     );
// };

// export default ReturnsAndRefundPolicy;